import React from 'react';
import './styles.scss';

class NotFoundView extends React.Component {

  render() {
    return (
      <div id="page-not-found">
        <div className="container-fluid content">
          <div className="row">
            <div className="col-12 bg-fff-50 border-grey">
              <h2 className="no-page">Page not found.</h2>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default NotFoundView;
